import Vue from 'vue'
import VueGoodTablePlugin from 'vue-good-table'

import 'vue-good-table/dist/vue-good-table.min.css'

Vue.use(VueGoodTablePlugin)